import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export interface FlaggedEmailFilters {
  reason?: string;
  resolved?: string;
  search?: string;
  from?: string;
  to?: string;
  page?: number;
  limit?: number;
}

export const useGetFlaggedEmails = (
  filters: FlaggedEmailFilters = {},
  enabled: boolean = true
): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.FLAGGED_EMAILS, filters],
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      staleTime: 30 * 1000,
      cacheTime: 5 * 60 * 1000,
    }
  );
};
